import { render } from "./new-child-fields.vue?vue&type=template&id=1919273a&scoped=true"
import script from "./new-child-fields.vue?vue&type=script&lang=js"
export * from "./new-child-fields.vue?vue&type=script&lang=js"

import "./new-child-fields.vue?vue&type=style&index=0&id=1919273a&scoped=true&lang=scss"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1919273a"]])

export default __exports__